import React from 'react';

import { Table } from 'vindi-ds-components';

const EmptyStateCharges = () => (
  <Table.EmptyState
    texts={{
      headerText: 'Nenhuma cobrança encontrada',
      bodyText: 'Quando existirem cobranças, elas aparecerão aqui.',
    }}
  />
);

export default EmptyStateCharges;
